import React from 'react'
import { useCanInsertAudioIntoSlidesMutation } from '@mote/api'
import { Block, Button, Input } from '@mote/ui'
import { Content, DefaultLayout } from '../layouts'
import { getAccessToken } from '../shared/Auth'

export function SlideProbeScreen() {
  const [state, setState] = React.useState({
    loggedIn: Boolean(getAccessToken()),
    containingURL: '',
    canInsert: '',
    error: '',
    errorCode: '',
    errorPhase: '',
    exception: ''
  })

  const {
    error,
    data,
    loading,
    mutate: canInsertAudioIntoSlides
  } = useCanInsertAudioIntoSlidesMutation()

  function resetState() {
    setState(prev => ({
      ...prev,
      canInsert: '',
      error: '',
      errorCode: '',
      errorPhase: '',
      exception: ''
    }))
  }

  function runProbe() {
    resetState()

    canInsertAudioIntoSlides({
      variables: {
        accessToken: getAccessToken(),
        containingURL: state.containingURL,
        lastLoginHostname: window.location.hostname
      }
    })
  }

  function renderLoggedIn() {
    return (
      <Block gap={10}>
        <p>
          <b>Please copy and paste your Google Slides URL below:</b>
        </p>
        <Input
          type='text'
          value={state.containingURL}
          onChange={e =>
            setState(prev => ({
              ...prev,
              containingURL: e.target.value.trim()
            }))
          }
        />

        <p>
          <Button
            onClick={() => runProbe()}
            disabled={loading}
            text={loading ? 'Testing...' : 'Test'}
          />
        </p>

        {error && (
          <div>
            <p>
              We got this error which is probably unrelated to your Slides
              problem:{' '}
            </p>

            <p>
              <font color='red'>{error}</font>
            </p>

            <p>Try again later or contact support@mote.com</p>
          </div>
        )}

        <div>
          {!loading && data && (
            <React.Fragment>
              {data.canInsert && (
                <div>
                  <b>All good!</b> No errors returned. You should be able to
                  successfully insert your <b className='mote-purple'>mote</b>{' '}
                  voice note into Google Slides.
                </div>
              )}

              {data.canInsert === false && (
                <div>
                  {' '}
                  <font color='red'>
                    <h4>PROBLEMS</h4>
                  </font>
                  <p>
                    <b>Error code: </b> {data.errorCode}{' '}
                  </p>
                  <p>
                    <b>Error phase: </b> {data.errorPhase}{' '}
                  </p>
                  <p>
                    {data.exception && (
                      <span>
                        <b>Exception:</b> {data.exception}
                      </span>
                    )}
                  </p>
                  <p className='lead'>
                    Please check out{' '}
                    <a href='https://support.mote.com/hc/en-us/articles/4409900671252'>
                      this article on our help site
                    </a>{' '}
                    for tips on how to resolve your issue.
                  </p>
                </div>
              )}
            </React.Fragment>
          )}
        </div>
      </Block>
    )
  }

  function renderLoginButton() {
    return (
      <div>
        <p>You need to be logged in to use this feature</p>

        <Button
          tag='a'
          href='/login?addScope=pseudo:google_slides_audio_insert&returnTo=/support/testSlides'
          text="Let's do it"
        />
      </div>
    )
  }

  return (
    <DefaultLayout>
      <Content>
        <h3>Let's test your Mote for Google Slides setup</h3>

        {state.loggedIn && renderLoggedIn()}
        {!state.loggedIn && renderLoginButton()}
      </Content>
    </DefaultLayout>
  )
}
